import React from 'react';
import {Box, Grid, Button} from '@material-ui/core';
import {MetaTags} from 'react-meta-tags';
import { makeStyles } from '@material-ui/core/styles';
import Header from "./HeaderMy";
import LeftDrawer from "../components/LeftDrawer";
import '../styles/bizofficer-a.css';
  
const useStyles = makeStyles((theme) => ({
	content: {
	  [theme.breakpoints.up('md')]: {
		marginLeft:240,
		marginTop:60,
	  },
	  padding: theme.spacing(1),
	},
  }));

  export default function Execute() {
	const classes = useStyles();
	var selectedCourse = localStorage.getItem('etlSelectCourse'); 
	var mySelectedCourses = JSON.parse(localStorage.getItem('etlMyCourses'));
  
  	const [organisationName, setOrganisationName] = React.useState("");

	  React.useEffect(() => {
			if(mySelectedCourses!==null && selectedCourse>=0){
				setOrganisationName(mySelectedCourses[selectedCourse].organisationName);
			}
		}, [mySelectedCourses, selectedCourse]);
		

		function upgradeNow(){
			if(mySelectedCourses && selectedCourse>-1){
				window.location.href="selectcourse?cid="+mySelectedCourses[selectedCourse].courseId;
			}
		}
		
	return (
		<div> 
				<MetaTags>
            		<title>Validity has been finished</title>
          		</MetaTags>
				
			  	<Header />	
				<LeftDrawer />
				<main className={classes.content}>
					

					<Box mt={1}>
						<Grid container spacing={2}>						
							<Grid item md={12}>
								<h2 style={{marginTop:'8%', textAlign:'center',color:'#FF0000',fontWeight:'bold'}}>
								{(organisationName && organisationName.length>0)?<>{organisationName}'s</>:null} validity has been finished. Upgrade your account to continue your practice.
								</h2>
								<div style={{textAlign: 'center'}}><Button title="Upgrade Now" variant="contained" onClick={() => {upgradeNow()}} size="small" style={{textTransform:'none',backgroundColor:'#008140',color:'#FFF'}} >Upgrade Now</Button></div>

							</Grid>								
						</Grid>
					</Box>

				</main>

		</div>	
	);
  }